import React, { Component } from 'react'
import cx from 'classnames'

import './style.scss'

export default class ProgressBar extends Component {
    render() {
        const { variant, animated, width, label } = this.props

        return (
            <div className={'export-progress-progress-bar-wrapper'}>
                <div
                    style={{ width: `${width >= 10 ? width : 10}%` }}
                    className={cx('progress-bar', variant, animated && 'animated')}
                >
                    <span className={'progressbar-label'}>{label || ''}</span>
                </div>
            </div>
        )
    }
}
